<template>
  <main class="main-wrap">
    <div class="topChart-wrap">
      <CommonContainer
        :scale="styleContainer.topElectricChartStyle"
        :title="'理论'"
        :type-list="subcategoryNameList.理论"
        @handleTypesSelect="handleTypesSelected"
        v-if="$store.getters.getSystemType === '电磁空间'"
         @change="changeisShowChart"
      >
        <template slot-scope="scope">
          <BarChart
            ref="理论"
            :mode="'v'"
            :bar-data="categoryData.理论"
            :is-show-legend-default="scope.chartStatus.isShowEnlargedChart"
            v-if="scope.chartStatus.isShowChart"
          ></BarChart>
          <DetailTable
            :type-list="checkedSubcategoryNameList.理论"
            :table-data="tableData.理论"
            v-else
          ></DetailTable>
        </template>
      </CommonContainer>
    </div>

    <slot />

    <div class="topChart-wrap">
      <CommonContainer
        :scale="styleContainer.topElectricChartStyle"
        :title="'人才培养'"
        v-if="$store.getters.getSystemType === '电磁空间'"
        :type-list="subcategoryNameList.人才培养"
        @handleTypesSelect="handleTypesSelected"
         @change="changeisShowChart"
      >
        <template slot-scope="scope">
          <!-- <PieChart
          ref="人才培养"
            :pie-data="categoryData.人才培养"
            :pie-label-line="true"
            :pie-radius="['20%', '60%']"
            :is-show-legend-default="scope.chartStatus.isShowEnlargedChart"
            v-if="scope.chartStatus.isShowChart"
          ></PieChart> -->
          <BarChart
            ref="人才培养"
            :mode="'v'"
            :bar-data="categoryData.人才培养"
            :is-show-legend-default="scope.chartStatus.isShowEnlargedChart"
            v-if="scope.chartStatus.isShowChart"
          ></BarChart>

          <DetailTable
            :type-list="checkedSubcategoryNameList.人才培养"
            :table-data="tableData.人才培养"
            v-else
          ></DetailTable>
        </template>
      </CommonContainer>
    </div>
  </main>
</template>

<script>
import CommonContainer from "@/components/CommonContainer"
import BarChart from "@/components/Charts/BarChart"
// import PieChart from "@/components/Charts/PieChart"
// import LineChart from "@/components/Charts/LineChart"
import DetailTable from "@/components/Tables/DetailTable"
import "./topChart.scss"

export default {
  props: {
    categoryData: {
      type: Object,
      require: true,
    },
    tableData: {
      type: Object,
      require: true,
    },
    subcategoryNameList: {
      type: Object,
      require: true,
    },
    checkedSubcategoryNameList: {
      type: Object,
      require: true,
    },
  },
  components: {
    CommonContainer,
    BarChart,
    // LineChart,
    // PieChart,
    DetailTable,
  },
  data() {
    return {
      mapContainer: {
        mapTitle: "地图",
        selectedRegion: [],
      },
      styleContainer: {
        topChartStyle: { width: "22vw", height: "29vh" },
        topElectricChartStyle: { width: "22vw", height: "50vh" },
        footerChartStyle: { width: "47vw", height: "29vh" },
        chartScale: { width: "100%", height: "100%" },
      },
    }
  },
  computed: {
    watchSystemType() {
      return this.$store.getters.getSystemType
    },
  },
  watch: {
    watchSystemType: function (n) {
      console.log(`watch value ${n}`)
    },
  },
  methods: {
     changeisShowChart(val){
      this.$emit("change",val)
    },
    handleTypesSelected(obj) {
      this.$parent.handleTypesSelected(obj)
    },
  },
}
</script>
